import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUserDataWithPostCount } from '../../../../pages/auth/utils/firebase/userOperations';

const THUNK_TIMEOUT = 30000; // 30 seconds

export const fetchUserStats = createAsyncThunk(
  'profile/fetchUserStats',
  async (userId, { rejectWithValue }) => {
    try {
      const timeoutPromise = new Promise((resolve, reject) =>
        setTimeout(() => reject(new Error('Operation timed out')), THUNK_TIMEOUT)
      );
      // Race the actual operation against the timeout
      return await Promise.race([
        getUserDataWithPostCount(userId),
        timeoutPromise
      ]);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
